import { FormApi } from 'final-form';
import { get, set } from 'lodash';
import Component from 'vue-class-component';

import { MediaTransferHelper } from '@skinsoft/media-transfer-helper';
import { ReactiveVue } from '@skinsoft/reactive-vue';

import { DELETE_IMAGE_CLICK_TOPIC, IMAGE_UPLOADED_TOPIC } from '../../../busTopics';
import { MediaArea } from '../fields-areas/medias-area';

@Component({
    components: {
        sMediaArea: MediaArea
    },
    props: ["form", "fieldName"],
    template: require('./medias-fields-area.html')
})
export class MediasFieldsArea extends ReactiveVue {

    public fieldName: string;
    public form: FormApi;
    private $mediaTransferHelper: MediaTransferHelper;
    private mediaUploadInProgress: boolean = false;

    public mounted() {
        this.$on(IMAGE_UPLOADED_TOPIC, (fileData) => {
            this.uploadMedia(fileData)
        })

        this.$on(DELETE_IMAGE_CLICK_TOPIC, (event) => this.onImageDeleteClick(event))
    }

    public beforeDestroy() {
        this.$off(IMAGE_UPLOADED_TOPIC)
        this.$off(DELETE_IMAGE_CLICK_TOPIC)
    }

    public get associatedMediasFieldName() {
        return `${this.fieldName}.medias`;
    }

    public get firstMediaFieldName() {
        return `${this.fieldName}.first`;
    }

    public get reportMedias() {
        let medias: any[] = get(this.form.getState().values, this.associatedMediasFieldName)
        if (!medias) {
            medias = [];
            set(this.form.getState().values, this.associatedMediasFieldName, medias)
            return medias;
        }

        return medias.map(
            (media) => {
                return media.mediaId;
            }
        )
    }

    private onImageDeleteClick(event) {
        const medias = get(this.form.getState().values, this.associatedMediasFieldName);
        if (medias) {
            const removedMediaId = medias.splice(event.imageListIndex, 1)[0].mediaId
            if (removedMediaId === get(this.form.getState().values, this.firstMediaFieldName)) {
                this.modifyFirstMedia(null)
            }
        }
    }

    private modifyFirstMedia(mediaId) {
        set(this.form.getState().values, this.firstMediaFieldName, mediaId);
    }

    private async uploadMedia(fileData) {
        const formData = new FormData();
        formData.append("file", fileData.file)

        let medias: any[] = get(this.form.getState().values, this.associatedMediasFieldName)
        if (!medias) {
            medias = [];
        }
        this.mediaUploadInProgress = true;
        // Retrieving temp id and uploading the media on backend asynchronously
        const media = await this.$mediaTransferHelper.uploadMediaWithoutTempUrl(fileData.file.type, fileData.file, fileData.url);
        this.mediaUploadInProgress = false;

        medias.push(media)

        if (medias.length === 1) {
            this.modifyFirstMedia(media.mediaId)
        }

        this.form.submit();
    }
}